import { cn } from '@/lib/utils'
import { Checkbox } from '@/components/ui/checkbox'
import { CurrencyIcon } from '@/components/profile/CurrencyIcon'
import type { Currency } from '@/types/payment'

interface CurrencyGridItemProps {
	currency: Currency
	isSelected: boolean
	onCheckedChange: (checked: boolean) => void
}

export function CurrencyGridItem({ currency, isSelected, onCheckedChange }: CurrencyGridItemProps) {
	return (
		<label
			className={cn(
				'flex cursor-pointer items-center gap-2 rounded-xl border bg-secondary px-3 py-3 transition-colors',
				isSelected ? 'border-primary/60' : 'border-border hover:border-muted-foreground/40',
			)}
		>
			<CurrencyIcon code={currency.currency_code} symbolUrl={currency.symbol_url} size='sm' />
			<span className='min-w-0 flex-1 truncate text-sm font-semibold tracking-[-0.21px] text-foreground'>{currency.currency_code}</span>
			<Checkbox
				checked={isSelected}
				onCheckedChange={(checked) => onCheckedChange(checked === true)}
				aria-label={`Select ${currency.currency_name}`}
				className='border-muted-foreground/50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground'
			/>
		</label>
	)
}
